import React from "react";
import { Col, Row } from "antd";
import SummaryWrapper from "../../../IpEMR/InspectionSummaries/SummaryWrapper";
import {
  getLabelTag,
  getLabelTagInput,
  getLabelTagsArray,
  getLabelTagsWithDynamicInputs,
} from "../../../IpEMR/InspectionSummaries/constructTextFromValues";
import dayjs from "dayjs";
import {
  riskFactorOptions,
  riskOptions,
  weightLossOptions,
} from "../../../IpEMR/Options/dietAdviceOptions";
import { checkEmpty } from "../../../../helpers/utility";
import "../../../IpEMR/summary.css";
import NutritionistClinicalEvaluationForm from "../../../IpEMR/InspectionForms/ClinicalEvaluation/NutritionistClinicalEvaluationForm";
import NutritionistClinicalEvaluationSummary from "../../../IpEMR/InspectionSummaries/ClinicalEvaluation/NutritionistClinicalEvaluationSummary";
import NutritionistGoalsSummary from "../../../IpEMR/InspectionSummaries/Goals/NutritionistGoalsSummary";
import NutritionistDietAdviceSummary from "../../../IpEMR/InspectionSummaries/DietAdvice/NutritionistDietAdviceSummary";

const NutritionistReassessmentSummary = ({ data, formData }) => {
  const constructSummaryItems = () => {
    const summaryItems = [];
    const pushSummaryItem = (key, label, children) => {
      summaryItems.push({ key, label, children });
    };

    if (
      data?.observed_date ||
      data?.present_weight ||
      data?.current_diet_order ||
      data?.weight_loss_gain ||
      data?.rbs_fbs ||
      data?.bun_creat ||
      data?.triglyceride ||
      data?.sodium ||
      data?.potassium ||
      data?.hemoglobin ||
      data?.albumin ||
      data?.any_other
    ) {
      pushSummaryItem(
        "1",
        "Diet Details",
        <>
          {data?.observed_date &&
            getLabelTagInput(
              "Observed Date",
              dayjs(data?.observed_date).format("DD MMM,YYYY")
            )}
          {getLabelTagInput("Present Weight", data?.present_weight, "kgs")}
          {getLabelTagInput("Current Diet Order", data?.current_diet_order)}
          {getLabelTagInput(
            "Wt. Loss/Gain",
            getLabelTag(weightLossOptions, data?.weight_loss_gain)
          )}
          {getLabelTagInput("RBS/FBS", data?.rbs_fbs)}
          {getLabelTagInput("Bun/Creat", data?.bun_creat)}
          {getLabelTagInput("Triglyceride", data?.triglyceride)}
          {getLabelTagInput("Na+", data?.sodium)}
          {getLabelTagInput("Potassium", data?.potassium)}
          {getLabelTagInput("Hb", data?.hemoglobin)}
          {getLabelTagInput("Albumin", data?.albumin)}
          {getLabelTagInput("Any Other", data?.any_other)}
        </>
      );
    }

    if (checkEmpty(data?.nutritional_risk_factors)) {
      pushSummaryItem(
        "2",
        "Nutritional Risk Factors",
        <>
          {getLabelTagsArray(riskFactorOptions, data?.nutritional_risk_factors)}
          {getLabelTagsWithDynamicInputs(data?.nutritional_risk_factors_others)}
        </>
      );
    }

    if (data?.continued_nutritional_risk) {
      pushSummaryItem(
        "3",
        "Continued Nutritional Risk",
        getLabelTag(riskOptions, data?.continued_nutritional_risk)
      );
    }

    return summaryItems;
  };

  const summaryItems = constructSummaryItems();
  return (
    <Row className="summaries">
      <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
        <SummaryWrapper
          items={summaryItems}
          title={"Assessment"}
        />
        {checkEmpty(formData?.clinical_evaluation) && (
          <NutritionistClinicalEvaluationSummary formData={formData} />
        )}
      </Col>
      <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
        {checkEmpty(formData?.goals) && (
          <NutritionistGoalsSummary formData={formData} />
        )}
        {checkEmpty(formData?.diet_advice) && (
          <NutritionistDietAdviceSummary formData={formData} />
        )}
      </Col>
    </Row>
  );
};

export default NutritionistReassessmentSummary;
